// extracted by mini-css-extract-plugin
export default {"wrap":"styles_wrap__ZSMGT","formInput":"styles_formInput__rmzLJ","teamheader":"styles_teamheader__+mx1U","title":"styles_title__eT0VI","subTitle":"styles_subTitle__Icmdt"};